import XLSX from "xlsx";

export const convertExceltoJSON = async (data: File): Promise<unknown[]> =>
    new Promise((resolve, reject) => {
        const reader: FileReader = new FileReader();

        reader.onload = (event: any) => {
            var data = event.target.result;

            var workbook = XLSX.read(data, { type: "binary" });

            const JSONDataArray = XLSX.utils.sheet_to_json(
                workbook.Sheets[workbook.SheetNames[0]]
            );

            JSONDataArray.forEach((jsonData) => {
                delete (jsonData as any)["__rownum__"];
            });

            resolve(JSONDataArray);
        };

        reader.readAsBinaryString(data);
    });

// warning: JSON data needs to be in correct format (i.e. flat map)
export const downloadJSONasExcel = (jsonData: any, fileName: string) => {
    // convert json > worksheet
    const worksheet = XLSX.utils.json_to_sheet(jsonData);
    // create new workbook
    const new_workbook = XLSX.utils.book_new();
    // add sheet to workbook
    XLSX.utils.book_append_sheet(new_workbook, worksheet, "SheetJS");
    // download file (all handled)
    XLSX.writeFile(new_workbook, `${fileName}.xlsx`);
};
